import { render, staticRenderFns } from "./HeaderLoginStaff.vue?vue&type=template&id=727c6a88&scoped=true&"
import script from "./HeaderLoginStaff.vue?vue&type=script&lang=js&"
export * from "./HeaderLoginStaff.vue?vue&type=script&lang=js&"
import style0 from "./HeaderLoginStaff.vue?vue&type=style&index=0&id=727c6a88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727c6a88",
  null
  
)

export default component.exports